export default __webpack_public_path__ + "static/media/pool-location-1500x1744_new.75267240.jpeg";